import React from 'react';
import Styles from './statuses.module.scss';

export const OwnFinished: React.FC = () => (
  <div>
    <h3 className={Styles.Title}>完了しました</h3>
    <p className={Styles.Description}>すべての工事工程が完了しました</p>
  </div>
);
